import React, { createContext, useContext, useState } from "react";

// Which country the admin is working on. Australia keeps the original pages
// (AU database); India shows the India pages, which use India callables only.
export const DASHBOARD_COUNTRIES = [
  { code: "AU", label: "Australia" },
  { code: "IN", label: "India" },
];

const STORAGE_KEY = "mlfDashboardCountry";

// The India preview build (deploy-india-preview.ps1) pins the dashboard to India
// so it can never show or edit Australian data. Normal builds leave this unset.
export const FORCED_COUNTRY = process.env.REACT_APP_FORCED_COUNTRY === "IN" ? "IN" : null;

const readStoredCountry = () => {
  if (FORCED_COUNTRY) return FORCED_COUNTRY;
  try {
    return localStorage.getItem(STORAGE_KEY) === "IN" ? "IN" : "AU";
  } catch {
    return "AU";
  }
};

const DashboardCountryContext = createContext({ country: "AU", setCountry: () => {} });

export const DashboardCountryProvider = ({ children }) => {
  const [country, setCountryState] = useState(readStoredCountry);

  const setCountry = (code) => {
    if (FORCED_COUNTRY) return;
    const next = code === "IN" ? "IN" : "AU";
    setCountryState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // Selection just won't persist.
    }
  };

  return (
    <DashboardCountryContext.Provider value={{ country, setCountry }}>
      {children}
    </DashboardCountryContext.Provider>
  );
};

export const useDashboardCountry = () => useContext(DashboardCountryContext);
